import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';
import { Toast } from 'bootstrap'; 
import { requestOtp, verify_login } from "../../../api/lead";
import { useNavigate } from 'react-router-dom';

const LeadLogin = () => {
  const [otpRequested, setOtpRequested] = useState(false);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [show, setShow] = useState(false);
  const toastRef = useRef(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRequestOtp = async (e) => {
    e.preventDefault();

    if (!email) {
        alert('Please fill in all fields before submitting.'); 
        return;
    }
    let data = {
        "email": email
    }
    const response = await requestOtp(data);
    const toast = new Toast(toastRef.current);
    setMessage(response.message)
    toast.show();
    if (response.status === true && toastRef.current) {
        setOtpRequested(true);
    }
    handleClose();
  };

  const handleClose = () => setShow(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !otp) {
        alert('Please fill in all fields before submitting.'); 
        return;
    }
    let data = {
        "email": email,
        "otp": otp
    }

    const response = await verify_login(data);
    if (response && response.status === true && toastRef.current) {
        localStorage.setItem('authToken', response.data['token']);
        localStorage.setItem('userId', response.data['userId']);
        localStorage.setItem('type', response.data['user_type'])
        setOtpRequested(true);
        // alert('successfull')
        const naivgate_url = "/home/lead-list";
        navigate(naivgate_url);
    } else {
        const toast = new Toast(toastRef.current);
        setMessage(response.response['data']['message'])
        toast.show();
    }
    handleClose();
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center min-vh-100">
      <div className="card p-4 shadow-sm login-card">
        <div className="text-center mb-4">
          <img
            className="card-img-top menu-logo"
            src="/images/Original.png"
            alt="Achieversiq"
          />
        </div>
        <h4 className="text-center mb-3">Sign in</h4>
        <form onSubmit={otpRequested ? handleLogin : handleRequestOtp}>
          <div className="form-group mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="John.Doe@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={otpRequested}
            />
          </div>

          {otpRequested && (
            <div className="form-group mb-3">
              <label>Enter OTP</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter the OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
          )}

          {!otpRequested && (
            <div className="d-flex justify-content-end mb-3">
              <a href="/" className="text-primary small">Forgot password?</a>
            </div>
          )}

          <button type="submit" className="btn btn-primary w-100 mb-3">
            {otpRequested ? 'Login' : 'Request OTP'}
          </button>
        </form>
      </div>
      <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
          <div
            ref={toastRef}
            className="toast align-items-center text-bg-success border-0"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">{message}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
    </div>
  );
};

export default LeadLogin;
